import acquisitionTypes, {
  acquisitionTypeTitles,
} from '../../support/acquisitionTypes';
import {
  getRfSubscriptionAgreement,
  hasRemainingDownloads,
  resolveSubFamilyFromAgreement,
} from '../rfSubscriptionPredicates';
import { getRfSubscriptionTitleKey } from '../rfSubscriptionLabels';
import { type DownloadAgreement } from '../../../types/isomorphic/download.types';
import { type AcquisitionTypeRule } from './types';

const getSubscriptionDownloadTitle = (
  isSubscriptionExperienceActive: boolean,
  rfAgreement: DownloadAgreement
): string => {
  if (!isSubscriptionExperienceActive)
    return acquisitionTypeTitles.SUBSCRIPTION_DOWNLOAD;
  const subFamily = resolveSubFamilyFromAgreement(rfAgreement);
  return getRfSubscriptionTitleKey(subFamily);
};

const isGettyRfExhaustedDownloadSubcase = ({
  hasDownloadsAvailable,
  isRfRedownloadable,
  assetIsDownloadable,
  isCoveredByRf,
}: {
  hasDownloadsAvailable: boolean;
  isRfRedownloadable?: boolean;
  assetIsDownloadable: boolean;
  isCoveredByRf: boolean;
}): boolean =>
  !hasDownloadsAvailable &&
  !isRfRedownloadable &&
  assetIsDownloadable &&
  isCoveredByRf;

const subscriptionDownloadRule: AcquisitionTypeRule = ({
  hasRfSubscription,
  downloadAgreements,
  isSubscriptionExperienceActive,
  isRfRedownloadable,
  assetIsDownloadable,
  isCoveredByRf,
}) => {
  if (!hasRfSubscription) return null;

  const rfAgreement = getRfSubscriptionAgreement(downloadAgreements);
  if (!rfAgreement) return null;

  const hasDownloadsAvailable = hasRemainingDownloads(rfAgreement);
  const hasRfRedownloadEligibility = isRfRedownloadable === true;
  const canDownloadWithSubscription =
    hasDownloadsAvailable || hasRfRedownloadEligibility;

  if (
    !canDownloadWithSubscription &&
    !isGettyRfExhaustedDownloadSubcase({
      hasDownloadsAvailable,
      isRfRedownloadable: hasRfRedownloadEligibility,
      assetIsDownloadable,
      isCoveredByRf,
    })
  ) {
    return null;
  }

  const title = getSubscriptionDownloadTitle(
    isSubscriptionExperienceActive,
    rfAgreement
  );

  return {
    type: acquisitionTypes.SUBSCRIPTION_DOWNLOAD,
    title,
  };
};

export default subscriptionDownloadRule;
